<template>
  <v-card>
    <v-card-title>
      <div class="d-flex justify-space-between align-center" style="width:100%">
        <h3>Doctor by Prefecture</h3>
        <v-btn text color="rgb(0,170,221)" :loading="loading" @click="getData">Refresh</v-btn>
      </div>
    </v-card-title>

    <v-card-text>
      <v-data-table :headers="headers" :items="data" :loading="loading"></v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios";
export default {
  created() {
    this.getData();
  },

  data() {
    return {
      headers: [
        {
          text: "Prefecture",
          value: "prefectureName"
        },
        {
          text: "Count",
          value: "doctorCount"
        }
      ],

      data: [],
      loading: false
    };
  },

  methods: {
    getData() {
      this.loading = true;
      axios
        .get(`${process.env.VUE_APP_BASE_URL}admin/prefectureDoctors`)
        .then(res => {
          console.log(res);
          this.data = res.data;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    }
  }
};
</script>